import { EntityDocumentsOrderBy } from '../../../common/types/globalTypes';
import { OrderDirection, OrderLookup, SortOrder } from 'common/utils/commonTypes';
import { FilterArrayType } from 'common/components/Filters';

const orderByMap = new Map<string, OrderLookup>([
  [
    'documentType',
    {
      [OrderDirection.ASC]: [
        'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__DOCUMENT_TYPE_ASC',
      ],
      [OrderDirection.DESC]: [
        'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__DOCUMENT_TYPE_DESC',
      ],
    },
  ],
  [
    '_documentPoolName',
    {
      [OrderDirection.ASC]: ['_DOCUMENT_POOL_NAME_ASC'],
      [OrderDirection.DESC]: ['_DOCUMENT_POOL_NAME_DESC'],
    },
  ],
  [
    'indexName',
    {
      [OrderDirection.ASC]: ['INDEX_NAME_ASC'],
      [OrderDirection.DESC]: ['INDEX_NAME_DESC'],
    },
  ],
  [
    'indexReferenceNumber',
    {
      [OrderDirection.ASC]: ['INDEX_REFERENCE_NUMBER_ASC'],
      [OrderDirection.DESC]: ['INDEX_REFERENCE_NUMBER_DESC'],
    },
  ],

  [
    'fileReference',
    {
      [OrderDirection.ASC]: ['FILE_REFERENCE_ASC'],
      [OrderDirection.DESC]: ['FILE_REFERENCE_DESC'],
    },
  ],
  [
    'indexTransactionDate',
    {
      [OrderDirection.ASC]: ['INDEX_TRANSACTION_DATE_ASC'],
      [OrderDirection.DESC]: ['INDEX_TRANSACTION_DATE_DESC'],
    },
  ],
  [
    '_documentContents',
    {
      [OrderDirection.ASC]: ['_DOCUMENT_CONTENTS_ASC'],
      [OrderDirection.DESC]: ['_DOCUMENT_CONTENTS_DESC'],
    },
  ],
  [
    'indexAmount',
    {
      [OrderDirection.ASC]: ['INDEX_AMOUNT_ASC'],
      [OrderDirection.DESC]: ['INDEX_AMOUNT_DESC'],
    },
  ],
  [
    'isoCode',
    {
      [OrderDirection.ASC]: [
        'COMPANY_CURRENCY_BY_INDEX_CURRENCY_ID__ISO_CODE_ASC',
      ],
      [OrderDirection.DESC]: [
        'COMPANY_CURRENCY_BY_INDEX_CURRENCY_ID__ISO_CODE_DESC',
      ],
    },
  ],
  [
    '_isSelected',
    {
      [OrderDirection.ASC]: ['_IS_SELECTED_ASC'],
      [OrderDirection.DESC]: ['_IS_SELECTED_DESC'],
    },
  ],
  [
    '_isVerified',
    {
      [OrderDirection.ASC]: ['_IS_VERIFIED_ASC'],
      [OrderDirection.DESC]: ['_IS_VERIFIED_DESC'],
    },
  ],
  [
    'comment',
    {
      [OrderDirection.ASC]: ['COMMENT_ASC'],
      [OrderDirection.DESC]: ['COMMENT_DESC'],
    },
  ],
  [
    '_uploadDate',
    {
      [OrderDirection.ASC]: ['_UPLOAD_DATE_ASC'],
      [OrderDirection.DESC]: ['_UPLOAD_DATE_DESC'],
    },
  ],
]);

export const toOrderByVariable = (sort?: SortOrder) => {
  const orderByArray: EntityDocumentsOrderBy[] = ['PRIMARY_KEY_ASC'];
  if (!sort) return orderByArray;
  const orderBy = orderByMap.get(sort.column)?.[sort.direction];
  return [...(orderBy ? orderBy : []), ...orderByArray];
};

export const toFilterVariable = (filterList: FilterArrayType[]) =>
  filterList
    .map((filter) => {
      switch (filter.filterKey) {
        case 'documentTypeId':
        case '_createdByUserid':
        case '_documentPoolId':
          return {
            [filter.filterKey]: {
              equalTo: filter.value,
            },
          };
        case '_isVerified':
        case '_isSelected':
          if (filter.value !== 'all')
            return {
              [filter.filterKey]: {
                equalTo: filter.value === 'true',
              },
            };
          else return undefined;
        default:
          return undefined;
      }
    })
    .filter((i) => i);
